import { Box, Stack } from '@mui/material'
import HealthIcon from 'assets/HealthIcon'
import { useWidgetStatistics } from 'components/farm-dashboard/hooks/useWidgetStatistics'
import { roundingNumber } from 'components/shared/processes'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { BaseWidget } from '../baseWidget'

export const DisposeRecommendedWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { statistics, loading, error } = useWidgetStatistics()

	if (!permissions?.license_limpness || error) return null

	const count = statistics?.dispose_recommended?.count ?? 0
	const isMore = statistics?.dispose_recommended?.more
	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.error10,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<HealthIcon color={COLORS.error} />
				</Box>
			}
			path={'/cattles/lameness'}
			isLoading={loading}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='row' alignItems='center' gap='6px'>
					<TypographyPrimary16Bold
						sx={{ color: count === 0 ? COLORS.icon : COLORS.error }}
					>
						{roundingNumber(count, 0).toLocaleString()}
					</TypographyPrimary16Bold>
					{/* {count !== 0 && (
						<ArrowCupidon
							iconColor={isMore ? COLORS.error : COLORS.success}
							direction={isMore ? 'up' : 'down'}
						/>
					)} */}
				</Stack>

				<TypographyPrimary>Рекомендовано к выбытию</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
